export function hexToRgb(hex) {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, '');

  // Parse the R, G, B values
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);

  return { red, green, blue }; // Return an object with R, G, B values
}

export function getOptimalTextColor(hex) {
  if (!hex) {
    return '#333333';
  }
  // Remove the hash at the start if it's there
  const { red, green, blue } = hexToRgb(hex);

  // Calculate luminance
  const luminance = 0.299 * red + 0.587 * green + 0.114 * blue;

  // Determine text color
  return luminance > 128 ? '#333333' : '#FFFFFF'; // Black or white
}
